import {
  Checkbox,
  Divider,
  FormControlLabel,
  Typography,
  makeStyles,
} from "@material-ui/core";
import React, { Fragment, useCallback, useMemo } from "react";
import { useForm, useFormState } from "react-final-form";

import { get } from "lodash";
import { useTranslate } from "ra-core";
import { Group, GroupTitle, useFieldLabel } from "ra-friendsofbabba";

const FIELDS = {
  municipality_id: [],
  title: [],
  position: [],
  institutions: ["has_other_institutions", "other_institutions"],
  dates: ["work_start_at", "work_end_at"],
  determine: ["determine_number", "determine_date", "cup_code"],
  amounts: [
    "amount_base",
    "amount_engineering",
    "amount_general",
    "amount_unexpected_events",
    "amount_vat",
    "amount_vat_and_other_charges",
    "amount_co_financing",
    "amount_requested",
  ],
  tro: [
    "tro_name",
    "tro_surname",
    "tro_birth_date",
    "tro_birth_place",
    "tro_birth_province",
    "tro_fiscal_code",
    "tro_email",
    "tro_pec",
    "tro_phone",
  ],
  lr: [
    "lr_name",
    "lr_surname",
    "lr_birth_date",
    "lr_birth_place",
    "lr_birth_province",
    "lr_fiscal_code",
    "lr_email",
    "lr_pec",
    "lr_phone",
  ],
  project_media: [],
  project_docs: [],
  provision: [],
};

const useStyles = makeStyles((theme) => ({
  label: {
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    fontWeight: "bold",
  },

  helperText: {
    padding: theme.spacing(1),
  },

  field: {
    paddingLeft: theme.spacing(2),
  },
  subfield: {
    width: 350,
    display: "inline-block",
    paddingLeft: theme.spacing(2),
  },
}));
const PermissionsField = ({ disabled, ...props }) => {
  const fieldLabel = useFieldLabel({ ...props });
  const classes = useStyles();
  const formState = useFormState();
  const form = useForm();
  const translate = useTranslate();
  const permissions = get(formState.values, props.source, []);
  const checked = useMemo(
    () =>
      Object.keys(FIELDS).reduce(
        (data, field) => ({
          ...data,
          // Aggiungo i campi (eventualmente) presenti nella sezione.
          ...get(FIELDS, field).reduce(
            (subfields, subfield) => ({
              ...subfields,
              [subfield]:
                permissions.find((p) => p.name === subfield) !== undefined,
            }),
            {}
          ),
          // Aggiungo il campo sezione con il suo relativo stato.
          [field]: permissions.find((p) => p.name === field) !== undefined,
        }),
        {}
      ),
    [permissions]
  );
  const handleCheck = useCallback(
    (field, subfield) => {
      let perms = [...permissions];
      let key = subfield !== false ? subfield : field;
      if (perms.find((p) => p.name === key)) {
        perms = perms.filter((p) => p.name !== key);
        if (subfield === false) {
          // Rimuovo tutti i campi associati alla sezione.
          const subfields = get(FIELDS, field);
          perms = perms.filter((p) => subfields.indexOf(p.name) === -1);
        } else {
          const subfields = get(FIELDS, field);
          const selection = perms.filter(
            (p) => subfields.indexOf(p.name) !== -1
          );
          if (subfields.length > 0 && selection.length === 0) {
            // Rimuovo la sezione poiché non ci sono campi interni
            // selezionati.
            perms = perms.filter((p) => p.name !== field);
          }
        }
      } else {
        perms.push({ name: key });
        if (subfield === false) {
          // Sto aggiungendo un campo di tipo sezione, pertanto
          // provvedo anche a caricare tutti i fields presenti
          // all'interno dello stesso.
          const subfields = get(FIELDS, field);
          perms = perms.concat(
            subfields.map((subfield) => ({ name: subfield }))
          );
        } else if (!perms.find((p) => p.name === field)) {
          // Aggiungo la sezione, l'utente ha cliccato direttamente
          // su un campo presente all'interno della stessa.
          perms.push({ name: field });
        }
      }
      form.change(props.source, perms);
    },
    [permissions, form, props.source]
  );

  return (
    <Group wrapper>
      <GroupTitle title={fieldLabel(props.source)} />
      <Typography variant="body2" className={classes.helperText}>
        <span
          dangerouslySetInnerHTML={{
            __html: translate(
              `resources.${props.resource}.fields.${props.source}.help`
            ),
          }}
        />
      </Typography>

      {Object.keys(FIELDS).map((field) => (
        <Fragment key={field}>
          <FormControlLabel
            className={classes.field}
            control={
              <Checkbox
                checked={get(checked, field, false)}
                name={field}
                onChange={handleCheck.bind(this, field, false)}
              />
            }
            label={<strong>{fieldLabel(field)}</strong>}
          />
          <Divider />
          {get(FIELDS, field).map((subfield) => (
            <FormControlLabel
              key={subfield}
              className={classes.subfield}
              control={
                <Checkbox
                  checked={get(checked, subfield, false)}
                  name={subfield}
                  onChange={handleCheck.bind(this, field, subfield)}
                />
              }
              label={fieldLabel(subfield)}
            />
          ))}
          {FIELDS[field].length > 0 && <Divider />}
        </Fragment>
      ))}
    </Group>
  );
};

export default PermissionsField;
